export default __webpack_public_path__ + "static/media/MYSQL.3737d1ef.svg";